module.exports = __webpack_public_path__ + "static/media/study 3pic.801ad28b.png";